var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import appLocalizer from '../../types/global';
// Define the initial state using that type
const initialState = {
    isProductStatLoading: false,
    isProductsMovingToTrash: false,
    isProductsRestoring: false,
    isProductsDeleting: false,
    allProducts: null,
    trashedProducts: null,
    error: null,
    message: '',
    toastMessage: ''
};
export const fetchProductStat = createAsyncThunk('products/fetchProductStat', () => __awaiter(void 0, void 0, void 0, function* () {
    const productStatURL = `${appLocalizer.restUrl}/dap/v1/products/stat`;
    const res = yield axios.get(productStatURL, {
        headers: {
            'content-type': 'application/json',
            'X-WP-NONCE': appLocalizer.restNonce
        }
    });
    return res.data;
}));
export const moveProductsToTrash = createAsyncThunk('products/moveProductsToTrash', () => __awaiter(void 0, void 0, void 0, function* () {
    const deleteURL = `${appLocalizer.restUrl}/dap/v1/trash`;
    const res = yield axios.post(deleteURL, {}, {
        headers: {
            'content-type': 'application/json',
            'X-WP-NONCE': appLocalizer.restNonce
        }
    });
    return res.data;
}));
export const restoreTrashedProducts = createAsyncThunk('products/restoreTrashedProducts', () => __awaiter(void 0, void 0, void 0, function* () {
    const deleteURL = `${appLocalizer.restUrl}/dap/v1/restore`;
    const res = yield axios.post(deleteURL, {}, {
        headers: {
            'content-type': 'application/json',
            'X-WP-NONCE': appLocalizer.restNonce
        }
    });
    return res.data;
}));
export const deleteProductsPermanently = createAsyncThunk('products/deleteProductsPermanently', () => __awaiter(void 0, void 0, void 0, function* () {
    const deleteURL = `${appLocalizer.restUrl}/dap/v1/delete`;
    const res = yield axios.post(deleteURL, {}, {
        headers: {
            'content-type': 'application/json',
            'X-WP-NONCE': appLocalizer.restNonce
        }
    });
    return res.data;
}));
export const productsSlice = createSlice({
    name: 'products',
    initialState,
    reducers: {
        setMessage: (state, action) => {
            state.message = action.payload;
        },
        setToastMessage: (state, action) => {
            state.toastMessage = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchProductStat.pending, (state) => {
            state.isProductStatLoading = true;
        }),
            builder.addCase(fetchProductStat.fulfilled, (state, action) => {
                state.isProductStatLoading = false;
                state.allProducts = action.payload.total;
                state.trashedProducts = action.payload.trash;
                state.error = null;
            }),
            builder.addCase(fetchProductStat.rejected, (state, action) => {
                var _a;
                state.isProductStatLoading = false;
                state.error = ((_a = action.error) === null || _a === void 0 ? void 0 : _a.message) ? action.error.message : null;
            }),
            builder.addCase(moveProductsToTrash.pending, (state) => {
                state.isProductsMovingToTrash = true;
            }),
            builder.addCase(moveProductsToTrash.fulfilled, (state, action) => {
                state.isProductsMovingToTrash = false;
                state.allProducts = action.payload.total;
                state.trashedProducts = action.payload.trash;
                state.error = null;
                state.toastMessage = 'All products have been successfully moved to trash';
            }),
            builder.addCase(moveProductsToTrash.rejected, (state, action) => {
                var _a;
                state.isProductsMovingToTrash = false;
                state.error = ((_a = action.error) === null || _a === void 0 ? void 0 : _a.message) ? action.error.message : null;
            }),
            builder.addCase(restoreTrashedProducts.pending, (state) => {
                state.isProductsRestoring = true;
            }),
            builder.addCase(restoreTrashedProducts.fulfilled, (state, action) => {
                state.isProductsRestoring = false;
                state.allProducts = action.payload.total;
                state.trashedProducts = action.payload.trash;
                state.error = null;
                state.toastMessage = 'All products have been moved from trash';
            }),
            builder.addCase(restoreTrashedProducts.rejected, (state, action) => {
                var _a;
                state.isProductsRestoring = false;
                state.error = ((_a = action.error) === null || _a === void 0 ? void 0 : _a.message) ? action.error.message : null;
            }),
            builder.addCase(deleteProductsPermanently.pending, (state) => {
                state.isProductsDeleting = true;
            }),
            builder.addCase(deleteProductsPermanently.fulfilled, (state, action) => {
                state.isProductsDeleting = false;
                state.allProducts = action.payload.total;
                state.trashedProducts = action.payload.trash;
                state.error = null;
                state.toastMessage = 'All products have been deleted from trash';
            }),
            builder.addCase(deleteProductsPermanently.rejected, (state, action) => {
                var _a;
                state.isProductsDeleting = false;
                state.error = ((_a = action.error) === null || _a === void 0 ? void 0 : _a.message) ? action.error.message : null;
            });
    }
});
// Action creators are generated for each case reducer function
export const { setMessage, setToastMessage } = productsSlice.actions;
export default productsSlice.reducer;
